import { render } from "./ReviewPostViewer.vue?vue&type=template&id=589d8c1c&scoped=true&ts=true"
import script from "./ReviewPostViewer.vue?vue&type=script&lang=ts"
export * from "./ReviewPostViewer.vue?vue&type=script&lang=ts"

import "./ReviewPostViewer.vue?vue&type=style&index=0&id=589d8c1c&lang=postcss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-589d8c1c"]])

export default __exports__